import BaseService from "./base.js";

class PlayerVersionsService {
  load() {
    return BaseService.get(`/api/player-versions`);
  }
}

const playerVersionsService = new PlayerVersionsService();

export { playerVersionsService };
